<script>
/* eslint-disable */
import { mapGetters } from "vuex";
import noteIcon from "../../../static/assets/images/note-1.svg";
import noteIconActive from "../../../static/assets/images/note-2.svg";
import flagIcon1 from "../../../static/assets/images/flag-1.svg";
import flagIcon2 from "../../../static/assets/images/flag-2.svg";
import flagIcon3 from "../../../static/assets/images/flag-3.svg";
export default {
  name: "ActivityList",
  props: {
    type: {
      type: String,
    },
  },
  components: {},
  data() {
    return {
      fetching: false,
      sorting: "",
      flagIcon1,
      noteIcon,
      noteIconActive,
      flagsListIcons: [flagIcon1, flagIcon2, flagIcon3],
      limit: 25,
      currentPageNumber: 1,
      searchStr: null,
      searchResult: true,
      rows: 3,
      fields: [
        {
          key: "flag_intensity",
          sortable: true,
          class: "icon-table-header flag-table",
        },
        {
          key: "flag_internal_notes",
          sortable: true,
          class: "icon-table-header note-table",
        },
        {
          key: "type",
          sortable: true,
        },
        {
          key: "uid",
          sortable: true,
          label: "ID",
        },
        {
          key: "working_title",
          label: "Xali Name",
          sortable: true,
        },
        {
          key: "series",
          sortable: true,
        },
        {
          key: "levels",
          sortable: true,
        },
        {
          key: "emotion",
          sortable: true,
        },
        {
          key: "intensity",
          label: "INT",
          sortable: true,
        },
        {
          key: "status",
          sortable: true,
        },
      ],
    };
  },
  computed: {
    ...mapGetters({
      coloursOptions: "commons/coloursOptions",
      currentPaginationPage: "commons/currentPaginationPage",
      currentDataList: "commons/currentDataList",
      fieldOptionsChunked: "commons/fieldOptionsChunked",
      notesOpened: "commons/notesOpened",
    }),
  },
  methods: {
    open(activity) {
      this.$store.commit(`commons/setActivity`, activity);
      this.$store.commit("commons/setOpenedNotes", true);
    },
    updateFlag(activity) {
      this.$store.commit("commons/setPreloader", true);
      var activityType = activity.type;
      if (activity.type == "stretch_flow") {
        activityType = "stretchflow";
      }
      const flag =
        activity.flag_intensity == 3 ? 1 : activity.flag_intensity + 1;
      this.$store.commit(`${activityType}s/setUpdateActivity`, {
        activity: activity,
        type: "flag_intensity",
        flag: flag,
      });
      this.$store
        .dispatch(`${activityType}s/updateFlag`, activity.id)
        .then((res) => {
          this.$store.commit("commons/setPreloader", false);
        });
    },
    optionValue(id, type) {
      const data =
        this.fieldOptionsChunked[type] && id
          ? this.fieldOptionsChunked[type].find((option) => option.id == id)
          : null;

      if (data) return data.label;
    },
    convertType(type) {
      return type == "stretch_flow" ? "stretch-flow" : type;
    },
    countPage() {
      return Math.ceil(this.currentDataList.count / this.limit);
    },
    sortingFunc(ctx) {
      this.sorting = ctx.sortDesc ? "-" : "";
      var sortby =
        ctx.sortBy == "working_title" ||
        ctx.sortBy == "type" ||
        ctx.sortBy == "created"
          ? ctx.sortBy
          : ctx.sortBy + "__label";

      this.sorting = this.sorting + sortby;

      var args = {
        limit: this.limit,
        offset: this.currentPageNumber,
        type: this.type,
      };

      if (this.searchStr) {
        args["search"] = this.searchStr;
      }
      if (this.sorting) {
        args["sorting"] = this.sorting;
      }

      this.fetchData(args, this.currentPageNumber);
    },

    fetchData(args, page) {
      this.fetching = true;
      this.searchResult = true;
      this.$store.commit("commons/setPreloader", true);
      this.$store.dispatch("commons/listByType", args).then(
        (res) => {
          this.$store.commit("commons/setPreloader", false);
          this.fetching = false;
        },
        (error) => {
          this.$store.commit("commons/setPreloader", false);
          this.fetching = false;
          console.log(error);
        }
      );
      this.$store.commit("commons/setCurrentPaginationPage", page);
    },

    page(number) {
      this.currentPageNumber = number;
      var args = {
        limit: this.limit,
        type: this.type,
        offset: this.currentPageNumber,
        search: this.searchStr,
      };
      if (this.sorting) {
        args["sorting"] = this.sorting;
      }
      this.fetchData(args, this.currentPageNumber);
    },
    next() {
      this.currentPageNumber = this.currentPageNumber + 1;
      var args = {
        limit: this.limit,
        type: this.type,
        offset: this.currentPageNumber,
        search: this.searchStr,
      };
      if (this.sorting) {
        args["sorting"] = this.sorting;
      }
      this.fetchData(args, this.currentPageNumber);
    },
    prev() {
      this.currentPageNumber = this.currentPageNumber - 1;
      var args = {
        limit: this.limit,
        type: this.type,
        offset: this.currentPageNumber,
        search: this.searchStr,
      };
      if (this.sorting) {
        args["sorting"] = this.sorting;
      }
      this.fetchData(args, this.currentPageNumber);
    },
    changelimit() {
      var args = {
        limit: this.limit,
        type: this.type,
        offset: 1,
        search: this.searchStr,
      };
      if (this.sorting) {
        args["sorting"] = this.sorting;
      }
      this.fetchData(args, 1);
    },
    search() {
      var args = {
        limit: this.limit,
        type: this.type,
        offset: 1,
        search: this.searchStr,
      };
      if (this.sorting) {
        args["sorting"] = this.sorting;
      }
      this.fetchData(args, 1);
    },
    clearSearch() {
      if (!this.searchStr) {
        this.search();
      }
    },
    clearSearchClick() {
      this.searchStr = "";
      this.search();
    },
    openActivity(activity, index) {
      this.$router.push(
        `/update-${this.convertType(activity.type)}/${activity.id}`
      );
    },
    activeColour(id) {
      return this.coloursOptions && id
        ? this.coloursOptions.find((option) => option.id == id)
        : null;
    },
    checkFlag(flag) {
      if (flag == 0) {
        return 1;
      }
      return flag;
    },
  },
};
</script>
<style lang="scss">
table {
  thead {
    th {
      &.icon-table-header {
        width: 20px;
        & > div {
          font-size: 0;
          width: 22px;
          height: 22px;
          background-position: center !important;
          background-size: cover !important;
          margin-right: 10px !important;
          cursor: pointer;
        }
        &.flag-table {
          & > div {
            background-image: var(--flagIcon1);
          }
        }
        &.note-table {
          & > div {
            background-image: var(--noteIcon);
          }
        }
      }
    }
  }
  tbody {
    td {
      &.icon-table-header {
        text-align: center;
      }
    }
  }
}
.pagination-wrapper {
  font-size: 14px;
}
.level-wrapper {
  span {
    background: #10b981;
    color: #fff;
    display: inline-block;
    width: 20px;
    height: 20px;
    text-align: center;
    margin: 0 2px;
    border-radius: 3px;

    &:first-child {
      background: #409176;
    }
  }
}


</style>
<template>
  <div
    class="data-list w-arrow"
    :class="currentDataList.results.length"
    :style="{
      '--flagIcon1': 'url(' + flagIcon1 + ')',
      '--noteIcon': 'url(' + noteIcon + ')',
    }"
  >
    <div class="filter d-flex align-items-center">
      <b-input-group>
        <b-form-input
          v-model="searchStr"
          type="text"
          placeholder="Search workouts by name, status, …"
          v-on:keyup.enter="search"
        ></b-form-input>
        <b-input-group-append>
          <b-input-group-text class="mr-2">
            <b-icon icon="search" v-if="!searchStr" />
            <b-icon
              icon="x-circle-fill"
              class="text-danger cursor-pointer"
              @click="clearSearchClick()"
              v-if="searchStr"
            />
          </b-input-group-text>
        </b-input-group-append>
      </b-input-group>
      <b-input-group-append>
        <b-button
          text="Button"
          variant="primary bg-white text-primary"
          @click="search()"
          >FILTER</b-button
        >
      </b-input-group-append>
    </div>

    <!-- @row-clicked="openActivity" -->
    <b-table
      @sort-changed="sortingFunc"
      :sticky-header="true"
      responsive
      :fields="fields"
      :items="fetching ? []  : currentDataList.results"
      v-if="searchResult"
    >
      <template #cell(flag_intensity)="data">
        <div class="icons">
          <span
            :style="{
              backgroundImage:
                'url(\'' +
                flagsListIcons[checkFlag(data.item.flag_intensity) - 1] +
                '\')',
            }"
            @click="updateFlag(data.item)"
          ></span>
        </div>
      </template>
      <template #cell(flag_internal_notes)="data">
        <div class="icons tooltip-wrapper">
          <span
            v-if="!data.item.flag_internal_notes"
            class="px-2 notes"
            :style="{
              backgroundImage: 'url(\'' + noteIcon + '\')',
            }"
            @click="open(data.item)"
          ></span>
          <span
            v-if="data.item.flag_internal_notes"
            class="px-2 has-note"
            :style="{
              backgroundImage: 'url(\'' + noteIconActive + '\')',
            }"
            @click="open(data.item)"
          >
          </span>

          <div class="data" v-if="data.item.flag_internal_notes">
            {{ data.item.flag_internal_notes }}
          </div>
        </div>
      </template>

      <template #cell(uid)="data">
        <b>
          <a
            v-bind:href="`#/update-${convertType(data.item.type)}/${
              data.item.id
            }`"
          >
            {{ data.item.uid }}
          </a>
        </b>
      </template>

      <template #cell(working_title)="data">
        <b>
          <a
            v-bind:href="`#/update-${convertType(data.item.type)}/${
              data.item.id
            }`"
          >
            {{ data.item.working_title }}
          </a>
        </b>
      </template>

      <template #cell(type)="data">
        <span
          class="badge inline-block type text-black"
          :style="{
            background: activeColour(data.item.colour)
              ? activeColour(data.item.colour).value
              : '',
          }"
          >{{ data.item.type }}</span
        >
      </template>

      <template #cell(series)="data"
        ><span>{{ optionValue(data.item.series, "SRS") }}</span></template
      >
      <template #cell(levels)="data">
        <div class="level-wrapper">
          <span v-for="level in data.item.levels" :key="level.id">
            {{ level }}
          </span>
        </div>
      </template>
      <template #cell(emotion)="data">
        <span v-if="data.item.type == 'stretch_flow'">{{
          optionValue(data.item.emotion, "STRETCHFLOW_EMO")
        }}</span>
        <span v-if="data.item.type != 'stretch_flow'">{{
          optionValue(data.item.emotion, "EMO")
        }}</span>
      </template>
      <template #cell(intensity)="data">
        <span v-if="data.item.type == 'stretch_flow'">{{
          optionValue(data.item.intensity, "STRETCHFLOW_HS")
        }}</span>
        <span v-if="data.item.type != 'stretch_flow'">{{
          optionValue(data.item.intensity, "HS")
        }}</span>
      </template>
      <template #cell(status)="data">
        <span class="badge inline-block">{{ data.item.status }}</span>
      </template>
    </b-table>

    <h2 v-if="!searchResult" class="text-center py-5">
      No "{{ searchStr }} " found
    </h2>

    <div
      class="
        pagination-wrapper
        d-flex
        justify-content-between
        align-items-center
        w-100
      "
      v-if="searchResult"
    >
      <div class="total">{{ currentDataList.count }} results</div>
      <div class="pagination">
        <ul
          role="menubar"
          aria-disabled="false"
          aria-label="Pagination"
          class="pagination b-pagination"
          v-if="countPage() != 1"
        >
          <li
            role="presentation"
            aria-hidden="true"
            class="page-item cursor-pointer"
            v-if="currentDataList.previous"
          >
            <span
              aria-label="Go to previous page"
              class="page-link text-primary"
              @click="prev()"
            >
              <b-icon icon="chevron-left" aria-hidden="true"></b-icon
            ></span>
          </li>
          <li
            class="page-item"
            v-for="item in countPage()"
            :key="item"
            :class="item == currentPaginationPage ? 'active' : ''"
          >
            <button class="page-link" @click="page(item)">{{ item }}</button>
          </li>
          <li
            role="presentation"
            aria-hidden="true"
            class="page-item cursor-pointer"
            v-if="currentDataList.next"
          >
            <span
              aria-label="Go to next page"
              class="page-link text-primary"
              @click="next()"
            >
              <b-icon icon="chevron-right" aria-hidden="true"></b-icon
            ></span>
          </li>
        </ul>
      </div>
      <div
        class="
          dropdown-pagination
          d-flex
          justify-content-end
          align-items-center
        "
      >
        <b-form-group class="select">
          <b-form-select v-model="limit" @change="changelimit()">
            <option value="25">25</option>
            <option value="50">50</option>
            <option value="100">100</option>
          </b-form-select>
        </b-form-group>
        Per page
      </div>
    </div>
  </div>
</template>